<template>
  <div>
    <CrudList
      title="Instrucciones"
      storeName="Stay_instructions"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      next-link="/admin/options"
      :breadcrumbs="[
        {
          text: 'Reservas y estadías',
          disabled: false,
          href: '/admin/stay_instructions'
        },
        {
          text: 'Instrucciones',
          disabled: false,
          href: '#'
        },
      ]"
    >
    <template v-slot:description="{item}">
      <v-container id="scroll-target"
                   style="max-height: 210px"
                   class="overflow-y-auto">
      <v-row v-scroll:#scroll-target="onScroll">
          <p> {{item.description}}</p>
      </v-row>
      </v-container>
    </template>
    <template v-slot:animation="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <template v-if="item.animation">
            <template v-if="isImage(item.animation)">
              <v-list-item-avatar>
                <img :src="item.animation" alt="Profile Picture" />
              </v-list-item-avatar>
            </template>
            <template v-else-if="isVideo(item.animation)">
              <div style="width: 150px">
                <video width="100%" controls>
                  <source :src="item.animation" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </template>
          </template>
        </v-col>
      </v-row>
    </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },
      isImage(url) {
      return /\.(gif|jpe?g|png|bmp|webp|svg)$/i.test(url);
      },
      isVideo(url) {
        return /\.(mp4|mkv|webm|ogg|avi)$/i.test(url);
      }
    },
  };
</script>
